/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { AppContext } from '../store/context'
import InstitutionEntity from '../utils/InstitutionEntity'
import Table from './Table'
import { distinctArray, filterArray } from '../utils/array-utils'
import { getInstitutionsForTable } from '../services/institution-services'
import { isCancel } from '../services/billing-services'
import { getNoDataMessage, TAB_INSTITUTIONS } from '../utils/TableUtils'

interface Props {
  onInstitutionSelected: (ids: string[]) => void
  onDataInstitutionSelected: (data: InstitutionEntity[]) => void
  finalKeptIds: string[]
}

// TABLE HEADERS & FILTERS
// -------------------
// filters
function textFilter({ column }: { column: any }) {
  const { filterValue = '', setFilter } = column
  return (
    <div>
      <input
        value={filterValue || ''}
        placeholder="Rechercher"
        onChange={(newValue) => {
          setFilter(newValue.currentTarget.value)
        }}
      />
    </div>
  )
}
function WasteRegisterSelector({
  onInstitutionSelected,
  onDataInstitutionSelected,
  finalKeptIds,
}: Props) {
  const { t } = useTranslation()
  const {
    state: { user, institution, organization },
  } = useContext(AppContext)
  const history = useHistory()
  // STATE
  const [isLoading, setIsLoading] = useState(false)
  const [tableDatas, setTableDatas] = useState<any[]>([])
  const [resultList, setResultList] = useState<string[]>([])
  const [institutionItemsDatas] = useState<InstitutionEntity[]>([])
  const [institutions, setInstitutions] = React.useState<InstitutionEntity[]>(
    []
  )
  const [nbPage, setNbPage] = useState<number>(1)
  const [tablePageCount, setTablePageCount] = useState(0)
  const [sortTable, setSortTable] = useState([])
  const [filters, setFilters] = React.useState<any[]>([])
  const [resetOrgaInsti, setResetOrgaInsti] = useState(false)
  const [nbPerPage, setNbPerPage] = useState(
    process.env.REACT_APP_TABLE_DEFAULT_RESULT_PER_PAGE
      ? parseInt(process.env.REACT_APP_TABLE_DEFAULT_RESULT_PER_PAGE, 10)
      : 10
  )
  const itemsSelectedLabel = `${
    resultList.length <= 1
      ? t('generic.selected.singular')
      : t('generic.selected.plural')
  }`

  // INITIAL SORT
  const initialSortBy = [
    {
      id: 'raisonSociale',
      asc: true,
    },
  ]
  // -------------------
  // TABLE HEADERS & FILTERS
  // -------------------
  // Headers
  const INSTUTIONS_TABLE = [
    {
      Header: 'Nom Ets',
      accessor: 'raisonSociale',
      Filter: textFilter,
    },
    {
      Header: 'Adresse',
      accessor: 'searchAdresse',
      Filter: textFilter,
    },
    {
      Header: 'Ville CP',
      accessor: 'searchVille',
      Filter: textFilter,
    },
    {
      Header: 'N° Client',
      accessor: 'searchText',
      Filter: textFilter,
    },
  ]

  // HANDLER
  const checkAll = (itemIds: string[]) => {
    const newResultList = distinctArray(finalKeptIds.concat(itemIds))
    setResultList([...newResultList])
    onInstitutionSelected(distinctArray([...newResultList]))
    institutions.forEach((elem: InstitutionEntity) => {
      if (!institutionItemsDatas.includes(elem))
        institutionItemsDatas.push(elem)
    })
    onDataInstitutionSelected(institutionItemsDatas)
  }
  const checkOne = (itemId: string) => {
    checkAll([itemId])
  }
  // Handler of table filters
  const handleFiltersChange = (filter: any[]) => {
    if (JSON.stringify(filter) !== JSON.stringify(filters)) {
      setNbPage(1)
      setFilters(filter)
    }
  }
  const formatedInstitutionsData = (institutionsItems: InstitutionEntity[]) => {
    return institutionsItems.map((institutionItem) => {
      return {
        id: institutionItem.id,
        raisonSociale: (
          <div className="wasteRegister__raisonSociale">
            {institutionItem.name}
          </div>
        ),
        searchAdresse: (
          <div className="wasteRegister__searchAdresse">
            {institutionItem.shortAdress}
          </div>
        ),
        searchVille: (
          <div className="wasteRegister__searchVille ">
            {institutionItem.villeCP}
          </div>
        ),
        searchText: (
          <div className="wasteRegister__searchText">
            {institutionItem.numDebiteur}
          </div>
        ),
      }
    })
  }
  async function LoadInstitionsAsync() {
    setIsLoading(true)
    const { results, pageCount } = await getInstitutionsForTable(
      nbPerPage,
      nbPage,
      organization.items,
      institution.items,
      sortTable,
      filters,
      history
    )

    if (isCancel(results)) {
      return
    }
    setTablePageCount(pageCount)
    if (results) {
      setInstitutions(results)
      setTableDatas(formatedInstitutionsData(results))
      setIsLoading(false)
    }
    setResetOrgaInsti(false)
  }

  useEffect(() => {
    if (
      user.roleNames.length === 0 ||
      organization.items === undefined ||
      institution.items === undefined
    )
      return
    LoadInstitionsAsync()
  }, [user, nbPage, nbPerPage, filters, sortTable])

  useEffect(() => {
    setNbPage(1)
    setFilters([])
    setResetOrgaInsti(true)
    setTableDatas([])
  }, [institution, organization])
  return (
    <>
      <div className="wasteRegister__right">
        <div className="wasteRegister_filterContainer">
          <div className="wasteRegister_selectedItemsCount">
            <p>
              {finalKeptIds.length} {itemsSelectedLabel}
            </p>
          </div>
        </div>
        <Table
          columns={INSTUTIONS_TABLE}
          data={tableDatas}
          checkedList={resultList.filter(
            (id) => !filterArray(resultList, finalKeptIds).includes(id)
          )}
          onSelectedItemChanged={checkOne}
          onCheckAll={checkAll}
          disabledList={finalKeptIds.filter(
            (id) => !filterArray(resultList, finalKeptIds).includes(id)
          )}
          onPageChange={setNbPage}
          nbPerPage={nbPerPage}
          onNbPerPageChange={setNbPerPage}
          pageCount={tablePageCount}
          isInternalPagination
          onSortTableChange={setSortTable}
          initialFilters={filters}
          onFiltersChange={handleFiltersChange}
          initialSortBy={initialSortBy}
          isLoading={isLoading}
          resetOrgaInsti={resetOrgaInsti}
          noDataAvailable={getNoDataMessage(TAB_INSTITUTIONS)}
        />
      </div>
    </>
  )
}

export default WasteRegisterSelector
